var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "full-size" }, [
    _c("div", { staticClass: "fix-top" }, [
      _c("div", { staticClass: "nav-box" }, [
        _c("ul", [
          _c("li", { staticClass: "active" }, [
            _c(
              "a",
              {
                attrs: { href: "javascript:void(0);" },
                on: {
                  click: function($event) {
                    return _vm.topage({ path: "/" })
                  }
                }
              },
              [_vm._v("主页")]
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _c(
              "a",
              {
                attrs: { href: "javascript:void(0);" },
                on: {
                  click: function($event) {
                    return _vm.topage({ path: "/product" })
                  }
                }
              },
              [_vm._v("产品列表")]
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _c(
              "a",
              {
                attrs: { href: "javascript:void(0);" },
                on: {
                  click: function($event) {
                    return _vm.topage({ path: "/news" })
                  }
                }
              },
              [_vm._v("理财资讯")]
            )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "main" }, [
      _c("div", { staticClass: "full-size index-main" }, [
        _c("div", { staticClass: "main-search" }, [
          _c("div", { staticClass: "search-box" }, [
            _c("i", { staticClass: "icon-search" }),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.searchInput,
                  expression: "searchInput"
                }
              ],
              staticClass: "text",
              attrs: {
                type: "text",
                placeholder: "请输入产品代码/名称/首字母",
                id: "search-input-home",
                autocomplete: "off"
              },
              domProps: { value: _vm.searchInput },
              on: {
                keydown: _vm.keydown,
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.searchInput = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _vm.searchInput.length > 0
              ? _c("i", {
                  staticClass: "icon-clear",
                  on: {
                    click: function($event) {
                      _vm.searchInput = ""
                    }
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "search-btn",
                attrs: { href: "javascript:void(0);" },
                on: {
                  click: function($event) {
                    return _vm.toSearch()
                  }
                }
              },
              [_vm._v("搜索")]
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "main-page" },
          [
            _c("probanner", {
              ref: "swipernew",
              staticClass: "swipernew",
              attrs: { data: _vm.htyxData }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "home-main new-main" }, [
              _c("div", { staticClass: "full-size" }, [
                _c("div", { staticClass: "ui layout" }, [
                  _c("div", { staticClass: "row-1" }, [
                    _c("div", { staticClass: "full-size" }, [
                      _c("div", { staticClass: "column" }, [
                        _c("div", { staticClass: "ui layout vertical part" }, [
                          _c("div", { staticClass: "title-box" }, [
                            _c("h5", [_vm._v("基金排行")]),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "more",
                                attrs: { href: "javascript:void(0);" },
                                on: {
                                  click: function($event) {
                                    return _vm.toMore("1")
                                  }
                                }
                              },
                              [_vm._v("更多")]
                            )
                          ]),
                          _vm._v(" "),
                          _vm.isFundInit
                            ? _c(
                                "div",
                                { staticClass: "nav-box" },
                                [
                                  _c(
                                    "swiper",
                                    {
                                      ref: "navswiper",
                                      attrs: { options: _vm.swiperOption }
                                    },
                                    _vm._l(_vm.fundType, function(item, key) {
                                      return _c(
                                        "swiper-slide",
                                        {
                                          key: key,
                                          class: [
                                            "nav-item",
                                            _vm.currType == item.type
                                              ? "active"
                                              : ""
                                          ],
                                          nativeOn: {
                                            click: function($event) {
                                              _vm.switchFundType(item.type)
                                              _vm.$refs.main01.scrollTop = 0
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: "javascript:void(0);"
                                              }
                                            },
                                            [_vm._v(_vm._s(item.text))]
                                          )
                                        ]
                                      )
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { ref: "main01", staticClass: "row-1 inner-box" },
                            [
                              !_vm.isFundInit
                                ? [_vm._m(0)]
                                : [
                                    _vm.currType == 0
                                      ? [
                                          _vm.FollowFund &&
                                          _vm.FollowFund.length > 0
                                            ? _c(
                                                "table",
                                                {
                                                  staticClass: "ct-table",
                                                  attrs: {
                                                    width: "100%",
                                                    cellspacing: "0",
                                                    cellpadding: "0"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "thead",
                                                    { ref: "thead01" },
                                                    [
                                                      _c(
                                                        "tr",
                                                        [
                                                          _c(
                                                            "th",
                                                            {
                                                              attrs: {
                                                                width: "50"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t序号\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "th",
                                                            {
                                                              attrs: {
                                                                width: "100"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t代码\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "th",
                                                            {
                                                              attrs: {
                                                                width: "50%"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t名称\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _vm.currType == "6" ||
                                                          _vm.currType == "lc"
                                                            ? [
                                                                _c("th", [
                                                                  _vm._v(
                                                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t万份收益\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                  )
                                                                ]),
                                                                _vm._v(" "),
                                                                _c("th", [
                                                                  _vm._v(
                                                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t七日年化\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                  )
                                                                ])
                                                              ]
                                                            : [
                                                                _c("th", [
                                                                  _vm._v(
                                                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t最新净值\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                  )
                                                                ]),
                                                                _vm._v(" "),
                                                                _c("th", [
                                                                  _vm._v(
                                                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t日涨跌幅\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                  )
                                                                ])
                                                              ]
                                                        ],
                                                        2
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.FollowFund &&
                                                  _vm.FollowFund.length > 0
                                                    ? _c(
                                                        "tbody",
                                                        _vm._l(
                                                          _vm.FollowFund,
                                                          function(
                                                            item,
                                                            index
                                                          ) {
                                                            return _c(
                                                              "tr",
                                                              {
                                                                key: index,
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.$router.push(
                                                                      {
                                                                        path:
                                                                          "/funddetail/" +
                                                                          item.fund_code
                                                                      }
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c("td", [
                                                                  _vm._v(
                                                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                      _vm._s(
                                                                        index +
                                                                          1
                                                                      ) +
                                                                      "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                  )
                                                                ]),
                                                                _vm._v(" "),
                                                                _c("td", [
                                                                  _vm._v(
                                                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                      _vm._s(
                                                                        item.fund_code
                                                                      ) +
                                                                      "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                  )
                                                                ]),
                                                                _vm._v(" "),
                                                                _c("td", [
                                                                  _c("p", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        item.fund_alias
                                                                      )
                                                                    )
                                                                  ])
                                                                ]),
                                                                _vm._v(" "),
                                                                item.navgrowthcalctype ==
                                                                "0"
                                                                  ? _c("td", [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "tip ared"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "*每万份收益"
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm._f(
                                                                                "parseFloatFormat"
                                                                              )(
                                                                                item.gain,
                                                                                "--",
                                                                                4,
                                                                                "1",
                                                                                ""
                                                                              )
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    ])
                                                                  : _c("td", [
                                                                      _vm._v(
                                                                        "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                          _vm._s(
                                                                            _vm._f(
                                                                              "parseFloatFormat"
                                                                            )(
                                                                              item.nav,
                                                                              "--",
                                                                              4,
                                                                              "1",
                                                                              ""
                                                                            )
                                                                          ) +
                                                                          "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                      )
                                                                    ]),
                                                                _vm._v(" "),
                                                                item.navgrowthcalctype ==
                                                                "0"
                                                                  ? _c("td", [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "tip ared"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "*7日年化收益率"
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          class: [
                                                                            item.yield >
                                                                            0
                                                                              ? "ared"
                                                                              : item.yield <
                                                                                0
                                                                              ? "agreen"
                                                                              : ""
                                                                          ]
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm._f(
                                                                                "parseFloatFormat"
                                                                              )(
                                                                                item.yield,
                                                                                "--",
                                                                                2,
                                                                                "1",
                                                                                "%"
                                                                              )
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    ])
                                                                  : _c("td", [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          class: [
                                                                            item.gain >
                                                                            0
                                                                              ? "ared"
                                                                              : item.gain <
                                                                                0
                                                                              ? "agreen"
                                                                              : ""
                                                                          ]
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm._f(
                                                                                "parseFloatFormat"
                                                                              )(
                                                                                item.gain,
                                                                                "--",
                                                                                2,
                                                                                100,
                                                                                "%"
                                                                              )
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    ])
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            : _c(
                                                "div",
                                                { staticClass: "no-data" },
                                                [_vm._m(1)]
                                              )
                                        ]
                                      : [
                                          _vm.fundList &&
                                          _vm.fundList.length > 0
                                            ? _c(
                                                "table",
                                                {
                                                  staticClass: "ct-table",
                                                  attrs: {
                                                    width: "100%",
                                                    cellspacing: "0",
                                                    cellpadding: "0"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "thead",
                                                    { ref: "thead01" },
                                                    [
                                                      _c(
                                                        "tr",
                                                        [
                                                          _c(
                                                            "th",
                                                            {
                                                              attrs: {
                                                                width: "50"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t序号\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "th",
                                                            {
                                                              attrs: {
                                                                width: "100"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t代码\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "th",
                                                            {
                                                              attrs: {
                                                                width: "50%"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t名称\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _vm.currType == "6" ||
                                                          _vm.currType == "lc"
                                                            ? [
                                                                _c("th", [
                                                                  _vm._v(
                                                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t万份收益\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                  )
                                                                ]),
                                                                _vm._v(" "),
                                                                _c("th", [
                                                                  _vm._v(
                                                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t七日年化\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                  )
                                                                ])
                                                              ]
                                                            : [
                                                                _c("th", [
                                                                  _vm._v(
                                                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t最新净值\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                  )
                                                                ]),
                                                                _vm._v(" "),
                                                                _c("th", [
                                                                  _vm._v(
                                                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t日涨跌幅\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                  )
                                                                ])
                                                              ]
                                                        ],
                                                        2
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.fundList &&
                                                  _vm.fundList.length > 0
                                                    ? _c(
                                                        "tbody",
                                                        _vm._l(
                                                          _vm.fundList,
                                                          function(
                                                            item,
                                                            index
                                                          ) {
                                                            return _c(
                                                              "tr",
                                                              {
                                                                key: index,
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.$router.push(
                                                                      {
                                                                        path:
                                                                          "/funddetail/" +
                                                                          item.fund_code
                                                                      }
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c("td", [
                                                                  _vm._v(
                                                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                      _vm._s(
                                                                        index +
                                                                          1
                                                                      ) +
                                                                      "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                  )
                                                                ]),
                                                                _vm._v(" "),
                                                                _c("td", [
                                                                  _vm._v(
                                                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                      _vm._s(
                                                                        item.fund_code
                                                                      ) +
                                                                      "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                  )
                                                                ]),
                                                                _vm._v(" "),
                                                                _c("td", [
                                                                  _c("p", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        item.fund_alias
                                                                      )
                                                                    )
                                                                  ])
                                                                ]),
                                                                _vm._v(" "),
                                                                item.navgrowthcalctype ==
                                                                "0"
                                                                  ? _c("td", [
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm._f(
                                                                                "formatNumber"
                                                                              )(
                                                                                _vm._f(
                                                                                  "parseFloatFormat"
                                                                                )(
                                                                                  item.gain,
                                                                                  "--",
                                                                                  4,
                                                                                  "1",
                                                                                  ""
                                                                                ),
                                                                                4
                                                                              )
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    ])
                                                                  : _c("td", [
                                                                      _vm._v(
                                                                        "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                          _vm._s(
                                                                            _vm._f(
                                                                              "formatNumber"
                                                                            )(
                                                                              _vm._f(
                                                                                "parseFloatFormat"
                                                                              )(
                                                                                item.nav,
                                                                                "--",
                                                                                4,
                                                                                "1",
                                                                                ""
                                                                              ),
                                                                              4
                                                                            )
                                                                          ) +
                                                                          "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                      )
                                                                    ]),
                                                                _vm._v(" "),
                                                                item.navgrowthcalctype ==
                                                                "0"
                                                                  ? _c("td", [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          class: [
                                                                            item.yield >
                                                                            0
                                                                              ? "ared"
                                                                              : item.yield <
                                                                                0
                                                                              ? "agreen"
                                                                              : ""
                                                                          ]
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm._f(
                                                                                "parseFloatFormat"
                                                                              )(
                                                                                item.yield,
                                                                                "--",
                                                                                2,
                                                                                "1",
                                                                                "%"
                                                                              )
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    ])
                                                                  : _c("td", [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          class: [
                                                                            item.gain >
                                                                            0
                                                                              ? "ared"
                                                                              : item.gain <
                                                                                0
                                                                              ? "agreen"
                                                                              : ""
                                                                          ]
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm._f(
                                                                                "parseFloatFormat"
                                                                              )(
                                                                                item.gain,
                                                                                "--",
                                                                                2,
                                                                                100,
                                                                                "%"
                                                                              )
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    ])
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            : _c(
                                                "div",
                                                { staticClass: "no-data" },
                                                [_vm._m(2)]
                                              )
                                        ]
                                  ]
                            ],
                            2
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "space-column" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "column" }, [
                        _c("div", { staticClass: "ui layout vertical part" }, [
                          _c("div", { staticClass: "title-box" }, [
                            _c("h5", [_vm._v("精选榜单")]),
                            _vm._v(" "),
                            _c("span", { staticClass: "info" }, [
                              _vm._v(_vm._s(_vm.rank_title))
                            ]),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "refresh",
                                attrs: { href: "javascript:void(0);" },
                                on: {
                                  click: function($event) {
                                    _vm.refreshRank()
                                    _vm.$refs.main02.scrollTop = 0
                                  }
                                }
                              },
                              [_vm._v("换一换")]
                            )
                          ]),
                          _vm._v(" "),
                          _vm.isTrendInit && _vm.RankingTypeTwo != ""
                            ? _c(
                                "div",
                                { staticClass: "nav-box" },
                                [
                                  _c(
                                    "swiper",
                                    {
                                      ref: "navswiper",
                                      attrs: { options: _vm.swiperOption }
                                    },
                                    _vm._l(_vm.RankingTypeTwo, function(
                                      item,
                                      key
                                    ) {
                                      return _c(
                                        "swiper-slide",
                                        {
                                          key: key,
                                          class: [
                                            "nav-item",
                                            _vm.currTwo == item.item_value
                                              ? "active"
                                              : ""
                                          ],
                                          nativeOn: {
                                            click: function($event) {
                                              _vm.switchTwo(item.item_value)
                                              _vm.$refs.main02.scrollTop = 0
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: "javascript:void(0);"
                                              }
                                            },
                                            [_vm._v(_vm._s(item.item_name))]
                                          )
                                        ]
                                      )
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { ref: "main02", staticClass: "row-1 inner-box" },
                            [
                              !_vm.isTrendInit
                                ? [_vm._m(3)]
                                : [
                                    _vm.RankingDetailTwo &&
                                    _vm.RankingDetailTwo[_vm.currTwo] &&
                                    JSON.parse(
                                      _vm.RankingDetailTwo[_vm.currTwo]
                                    ).length > 0
                                      ? _c(
                                          "table",
                                          {
                                            staticClass: "ct-table",
                                            attrs: {
                                              width: "100%",
                                              cellspacing: "0",
                                              cellpadding: "0"
                                            }
                                          },
                                          [
                                            _c("thead", { ref: "thead02" }, [
                                              _c("tr", [
                                                _c(
                                                  "th",
                                                  { attrs: { width: "50" } },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t序号\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  { attrs: { width: "100" } },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t代码\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  { attrs: { width: "50%" } },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t名称\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("th", [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        _vm.RankingListTwo
                                                          .col_sname
                                                      ) +
                                                      "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                  )
                                                ])
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _vm.RankingDetailTwo[_vm.currTwo] &&
                                            _vm.RankingDetailTwo[_vm.currTwo]
                                              .length > 0
                                              ? _c(
                                                  "tbody",
                                                  _vm._l(
                                                    JSON.parse(
                                                      _vm.RankingDetailTwo[
                                                        _vm.currTwo
                                                      ]
                                                    ),
                                                    function(item, index) {
                                                      return _c(
                                                        "tr",
                                                        {
                                                          key: index,
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.$router.push(
                                                                {
                                                                  path:
                                                                    "/funddetail/" +
                                                                    item.fund_code
                                                                }
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("td", [
                                                            _vm._v(
                                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                _vm._s(
                                                                  index + 1
                                                                ) +
                                                                "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("td", [
                                                            _vm._v(
                                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                _vm._s(
                                                                  item.fund_code
                                                                ) +
                                                                "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("td", [
                                                            _c("p", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.fund_alias
                                                                )
                                                              )
                                                            ])
                                                          ]),
                                                          _vm._v(" "),
                                                          item.col_value ||
                                                          item.col_unit
                                                            ? _c("td", [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    class: [
                                                                      item.col_value >
                                                                      0
                                                                        ? "ared"
                                                                        : item.col_value <
                                                                          0
                                                                        ? "agreen"
                                                                        : ""
                                                                    ]
                                                                  },
                                                                  [
                                                                    item.col_value
                                                                      ? [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              item.col_value
                                                                            )
                                                                          )
                                                                        ]
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    item.col_unit
                                                                      ? [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              item.col_unit
                                                                            )
                                                                          )
                                                                        ]
                                                                      : _vm._e()
                                                                  ],
                                                                  2
                                                                )
                                                              ])
                                                            : _c("td", [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t--\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ])
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      : _c("div", { staticClass: "no-data" }, [
                                          _vm._m(4)
                                        ])
                                  ]
                            ],
                            2
                          )
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "abreast-space" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "row-1" }, [
                    _c("div", { staticClass: "full-size" }, [
                      _c("div", { staticClass: "column" }, [
                        _c("div", { staticClass: "ui layout vertical part" }, [
                          _c("div", { staticClass: "title-box" }, [
                            _c("h5", [_vm._v("理财")]),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "more",
                                attrs: { href: "javascript:void(0);" },
                                on: {
                                  click: function($event) {
                                    return _vm.toMore("2")
                                  }
                                }
                              },
                              [_vm._v("更多")]
                            )
                          ]),
                          _vm._v(" "),
                          _vm.isFinanInit
                            ? _c(
                                "div",
                                { staticClass: "nav-box" },
                                [
                                  _c(
                                    "swiper",
                                    {
                                      ref: "navswiper",
                                      attrs: { options: _vm.swiperOption }
                                    },
                                    _vm._l(_vm.lc_search_list_qx_arr, function(
                                      item,
                                      index
                                    ) {
                                      return _c(
                                        "swiper-slide",
                                        {
                                          key: index,
                                          staticClass: "nav-item",
                                          class: {
                                            active: _vm.lc_search_index == index
                                          },
                                          nativeOn: {
                                            click: function($event) {
                                              _vm.switchDate(index)
                                              _vm.$refs.main03.scrollTop = 0
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: "javascript:void(0);"
                                              }
                                            },
                                            [_vm._v(_vm._s(item.text))]
                                          )
                                        ]
                                      )
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { ref: "main03", staticClass: "row-1 inner-box" },
                            [
                              !_vm.isFinanInit
                                ? [_vm._m(5)]
                                : [
                                    _vm.lc_search_data &&
                                    _vm.lc_search_data.length > 0
                                      ? _c(
                                          "table",
                                          {
                                            staticClass: "ct-table lc-table",
                                            attrs: {
                                              width: "100%",
                                              cellspacing: "0",
                                              cellpadding: "0"
                                            }
                                          },
                                          [
                                            _c("thead", { ref: "thead03" }, [
                                              _vm._m(6)
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "tbody",
                                              _vm._l(
                                                _vm.lc_search_data,
                                                function(item, index) {
                                                  return _c(
                                                    "tr",
                                                    {
                                                      key: index,
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.goFinanRouter(
                                                            item.cplx,
                                                            item.cpid,
                                                            1
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("td", [
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                            _vm._s(index + 1) +
                                                            "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("td", [
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                            _vm._s(item.cpid) +
                                                            "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("td", [
                                                        _c("p", [
                                                          _vm._v(
                                                            _vm._s(item.cpmc)
                                                          )
                                                        ])
                                                      ]),
                                                      _vm._v(" "),
                                                      item.isneedlogin &&
                                                      !_vm.checkLogin
                                                        ? _c("td", [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "tip",
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                    return _vm.goLogin(
                                                                      "/login",
                                                                      "/finadetail/" +
                                                                        item.cpid
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "登录查看"
                                                                )
                                                              ]
                                                            )
                                                          ])
                                                        : _c("td", [
                                                            _c("span", {
                                                              staticClass:
                                                                "ared",
                                                              domProps: {
                                                                innerHTML: _vm._s(
                                                                  item.show_field_value_html
                                                                )
                                                              }
                                                            }),
                                                            _vm._v(" "),
                                                            _c("p", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.otczg_syl_ms
                                                                )
                                                              )
                                                            ])
                                                          ]),
                                                      _vm._v(" "),
                                                      _c("td", [
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                            _vm._s(
                                                              item.fxdj_text
                                                            ) +
                                                            "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          ]
                                        )
                                      : _c("div", { staticClass: "no-data" }, [
                                          _vm._m(7)
                                        ])
                                  ]
                            ],
                            2
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "space-column" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "column" }, [
                        _c("div", { staticClass: "ui layout vertical part" }, [
                          _c("div", { staticClass: "title-box" }, [
                            _c("h5", [_vm._v("理财资讯")]),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "more",
                                attrs: { href: "javascript:void(0);" },
                                on: {
                                  click: function($event) {
                                    return _vm.toMore("3")
                                  }
                                }
                              },
                              [_vm._v("更多")]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row-1 inner-box" }, [
                            _c(
                              "div",
                              { staticClass: "news-list" },
                              [
                                !_vm.isNewsInit ? [_vm._m(8)] : _vm._e(),
                                _vm._v(" "),
                                _vm.isNewsInit && _vm.newsList.length == 0
                                  ? [_vm._m(9)]
                                  : [
                                      _c(
                                        "ul",
                                        _vm._l(_vm.newsList, function(
                                          item,
                                          index
                                        ) {
                                          return _c("li", { key: index }, [
                                            _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href: "javascript:void(0);"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.openNew(item)
                                                  }
                                                }
                                              },
                                              [_vm._v(_vm._s(item.Title))]
                                            )
                                          ])
                                        }),
                                        0
                                      )
                                    ]
                              ],
                              2
                            )
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showIframe,
            expression: "showIframe"
          }
        ],
        staticClass: "pop-mask"
      },
      [
        _c(
          "div",
          {
            staticClass: "pop-inner pop-iframe",
            style: {
              width: _vm.isFullIframe ? "100%" : "1200px",
              height: _vm.isFullIframe ? "100%" : "80%",
              "min-height": _vm.isFullIframe ? "100%" : "600px"
            }
          },
          [
            _c("div", { staticClass: "title-box" }, [
              _c("h5", [_vm._v("资讯详情")]),
              _vm._v(" "),
              _c("i", {
                staticClass: "icon-mini",
                on: {
                  click: function($event) {
                    _vm.isFullIframe = false
                  }
                }
              }),
              _vm._v(" "),
              _c("i", {
                staticClass: "icon-zoom",
                on: {
                  click: function($event) {
                    _vm.isFullIframe = true
                  }
                }
              }),
              _vm._v(" "),
              _c("i", {
                staticClass: "icon-close",
                on: {
                  click: function($event) {
                    _vm.showIframe = false
                    ;(_vm.isFullIframe = false), (_vm.tempItem = [])
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "scroll-box" }, [
              _c("iframe", {
                attrs: {
                  src: _vm.tempItem.LinkUrl,
                  width: "100%",
                  height: "100%",
                  frameborder: "0",
                  scrolling: "no"
                }
              })
            ])
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "no-data" }, [
      _c("div", { staticClass: "no-inner" }, [
        _c("i", { staticClass: "icon" }),
        _vm._v(" "),
        _c("p", [_vm._v("暂无数据")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "no-inner" }, [
      _c("i", { staticClass: "icon" }),
      _vm._v(" "),
      _c("p", [_vm._v("暂无数据")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "no-inner" }, [
      _c("i", { staticClass: "icon" }),
      _vm._v(" "),
      _c("p", [_vm._v("暂无数据")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "no-data" }, [
      _c("div", { staticClass: "no-inner" }, [
        _c("i", { staticClass: "icon" }),
        _vm._v(" "),
        _c("p", [_vm._v("暂无数据")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "no-inner" }, [
      _c("i", { staticClass: "icon" }),
      _vm._v(" "),
      _c("p", [_vm._v("暂无数据")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "no-data" }, [
      _c("div", { staticClass: "no-inner" }, [
        _c("i", { staticClass: "icon" }),
        _vm._v(" "),
        _c("p", [_vm._v("暂无数据")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", { attrs: { width: "50" } }, [
        _vm._v(
          "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t序号\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
        )
      ]),
      _vm._v(" "),
      _c("th", { attrs: { width: "100" } }, [
        _vm._v(
          "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t代码\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
        )
      ]),
      _vm._v(" "),
      _c("th", [
        _vm._v(
          "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t名称\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
        )
      ]),
      _vm._v(" "),
      _c("th", [
        _vm._v(
          "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t收益率\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
        )
      ]),
      _vm._v(" "),
      _c("th", { attrs: { width: "120" } }, [
        _vm._v(
          "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t风险等级\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "no-inner" }, [
      _c("i", { staticClass: "icon" }),
      _vm._v(" "),
      _c("p", [_vm._v("暂无数据")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "no-data" }, [
      _c("div", { staticClass: "no-inner" }, [
        _c("i", { staticClass: "icon" }),
        _vm._v(" "),
        _c("p", [_vm._v("暂无数据")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "no-data" }, [
      _c("div", { staticClass: "no-inner" }, [
        _c("i", { staticClass: "icon" }),
        _vm._v(" "),
        _c("p", [_vm._v("暂无数据")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-56b687e3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56b687e3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home.vue
// module id = null
// module chunks = 